import { createAsyncActions } from '~/utils/store';

export const FETCHQTDD = createAsyncActions('@@LEADS/FETCHQTDD');
export const MOVE = createAsyncActions('@@LEADS/MOVE');
export const SAVE_METRICS = createAsyncActions('@@LEADS/METRICS');
export const LOAD_LEADS = createAsyncActions('@@LEADS/LOAD');
export const LOAD_MORE_LEADS = createAsyncActions('@@LEADS/LOAD_MORE_LEADS');
export const LOAD_SUMMARY = createAsyncActions('@@LEADS/LOAD_SUMMARY');
export const LOAD_PROPOSALS = createAsyncActions('@@LEADS/LOAD_PROPOSALS');
export const SET_DATE = '@@LEADS/SET_DATE';

export const loadLeads = ({ month, year, ...params }) => {
    let url = "/leads";
    const queryParams = new URLSearchParams();
    
    if (month) queryParams.append('month', month);
    if (year) queryParams.append('year', year);
    
    if (queryParams.toString()) {
        url += '?' + queryParams.toString();
    }
    
    return {
        type: LOAD_LEADS.INIT,
        payload: {
            request: {
                method: "GET",
                url: url,
                showLoading: false,
                ...params
            }
        }
    };
};

export const loadMoreLeads = ({ columnId, currentCount, moreCount }) => ({
    type: LOAD_MORE_LEADS.INIT,
    payload: {
        request: {
            method: "GET",
            url: `/leads/more?stage=${columnId}&current_count=${currentCount}&more_count=${moreCount}`,
            showLoading: false,
        },
        columnId
    },
})

export const loadSummary = ({ ...params }) => ({
    type: LOAD_SUMMARY.INIT,
    payload: {
        request: {
            method: "GET",
            url: "/leads/summary",
            showLoading: false,
            ...params
        }
    }
});

export const fetchQtddByMonth = ({ date }) => ({
    type: FETCHQTDD.INIT,
    payload: {
        request:{
            method: 'get',
            url:`/leads/qtdd/${date}`,
            showLoading: false
        }
      }
});

export const move = (props) => ({
    type: MOVE.INIT,
    payload: {
        request:{
            method: 'put',
            url:`/leads/${props[4]}/move`,
            data: {to: props[3].droppableId},
            showLoading: false
        },
    },
    props: props
});

export const saveMetrics = (data) => ({
    type: SAVE_METRICS.INIT,
    payload: {
        request: {
            method: 'post',
            url: '/leads/metrics',
            showLoading: false,
            data
        }
    }
});

export const setDate = (date) => ({
    type: SET_DATE,
    payload: {
        date
    }
});

export const loadProposals = ({ month, year }) => ({
    type: LOAD_PROPOSALS.INIT,
    payload: {
        request: {
            method: "GET",
            url: "/leads/proposals",
            params: { month: month, year: year },
            showLoading: false
        }
    }
});